module.exports = __webpack_public_path__ + "static/process2-b99792ac2c43cc0e0bae2717dc4f3533.png";